export const SAVE_TOKEN_STARTED = "SAVE_TOKEN_STARTED";
export const SAVE_TOKEN_COMPLETED = "SAVE_TOKEN_COMPLETED";
export const SAVE_TOKEN_FAILED = "SAVE_TOKEN_FAILED";

export interface IToken {
  status: {
    statusCode: number;
    statusDisplay: string;
    statusValue: boolean;
  };
  items: Array<any>;
  TokenInput: {
    userId: string;
    password: string;
    securityQuestion: string;
    answer: string;
    roleFkId: {
      roleId: number;
      roleName: string;
      description: string;
      status: number;
      createdAt: Date;
      createdBy: string;
      updatedAt: Date;
      updatedBy: string;
    };
    status: number;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
  };
  TokenID: number;
  isLoading: boolean;
  error: string;
}

export const saveToken = (TokenInput: any) => {
    return {
    type: SAVE_TOKEN_STARTED,
    payload: "status",
    input: TokenInput
  };
};
